//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The seats.io session state enum
*
* 
*  * CONTINUE value: continue - session state continue 
*  * START value: start - session state start 
*  * MANUAL value: manual - session state manual 
*  * NONE value: none - session state none 
*/
@Serializable
enum class FloorPlanChartSession(val value: kotlin.String) {

    @SerialName(value = "continue")
    CONTINUE("continue"),

    @SerialName(value = "start")
    START("start"),

    @SerialName(value = "manual")
    MANUAL("manual"),

    @SerialName(value = "none")
    NONE("none");

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is FloorPlanChartSession) "$data" else null

    /**
    * Returns a valid [FloorPlanChartSession] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): FloorPlanChartSession? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

